<ng-container *ngIf="fGroup" [formGroup]="fGroup">
  <select tabindex="0" class="form-control border-0" formControlName="taxId">
    <option value="">{{ 'None' | translate }}</option>
    <option *ngFor="let tax of taxes$ | async" value="{{ tax.id }}">
      {{ tax._taxRates[0].rate }}% ({{ tax.abbreviation }})</option
    >
    <option value="newTax">{{ 'Add new tax' | translate }}</option>
  </select>
</ng-container>
